export function loadScript(url, config = { async: false, defer: false }) {
	return new Promise(function(resolve, reject){
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript'
		script.onload = resolve;
		script.onerror = reject;
		script.src = url;
		if (config.async) script.async = config.async;
		if (config.defer) script.defer = config.defer;
		head.appendChild(script)
	})
}
